import { Component, OnInit, ViewChild } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { MarketingTemplate } from "src/app/shared/models/MarketingTemplate.item";
import * as uuid from "uuid";
import { TemplateSetupComponent } from "./template-setup/template-setup.component";

@Component({
	selector: "app-templates",
	templateUrl: "./templates.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class TemplatesComponent implements OnInit {
	@ViewChild("templateSetup") templateSetup: TemplateSetupComponent;
	moment: any = moment;

	templateList: MarketingTemplate[];
	templateSelected: MarketingTemplate;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService, public userService: UserService) {}

	ngOnInit(): void {
		this.templateGet(this.venueService.subscriptionVenue.value.key);
	}

	async init() {}

	async templateGet(venueKey: number) {
		const resp = await this.focuslink.marketingTemplateGetAll(venueKey);
		this.templateList = resp.map((i) => new MarketingTemplate(i));
		console.log(this.templateList);
		this.app.loading(false);
	}

	templateNew() {
		this.templateSelected = new MarketingTemplate({
			pk: this.venueService.subscriptionVenue.value.key.toString(),
			sk: uuid.v4(),
			created: moment().format(),
			authorUserKey: this.userService.userSubscription.value.key,
		});
	}

	closeTemplateEditor(template: MarketingTemplate) {
		const idx = this.templateList.findIndex((i) => i.sk === template.sk);
		if (idx !== -1) {
			this.templateList[idx] = template;
		} else {
			this.templateList.push(template);
		}
		this.templateSelected = undefined;
	}
}
